import { Box, keyframes } from '@mui/material';

import { SKY } from './askSyntiroTheme';

const bounce = keyframes`
  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-4px); }
`;

export default function AskSyntiroLoadingDots() {
  return (
    <Box aria-hidden="true" sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
      {[0, 1, 2].map((dotIndex) => (
        <Box
          key={dotIndex}
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: SKY,
            animation: `${bounce} 1s infinite`,
            animationDelay: `${dotIndex * 0.15}s`
          }}
        />
      ))}
    </Box>
  );
}
